<script lang="ts">
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import BackbgroundStripes from "../Core/Elements/Components/BackbgroundStripes.svelte";

  export let SymetricalElements = 1;
  export let width = 300;
  export let activeElements = 1;
  export let backgroundColor = "#75c9b7";

  $: stepWidth = Math.round(width / activeElements);

  const tweenedWidth = tweened(0, {
    duration: 400,
    easing: cubicOut,
  });
  $: tweenedWidth.set(SymetricalElements * stepWidth);
</script>

{#key SymetricalElements}
  <div class="progressBar-wrapper" style="background-color:{backgroundColor}">
    <div class="progressBar" style=" right:{width - $tweenedWidth}px; ">
      <BackbgroundStripes
        stripesCount={50}
        color="#75c9b7"
        backgroundColor="#75c9b7"
        rotate={40}
        animate={false}
        spacing={10}
        stripWidth={5}
        top={-100}
        shadow
      />
    </div>
  </div>
{/key}

<style>
  .progressBar-wrapper {
    position: relative;
    display: flex;
    box-shadow: inset 2px 2px 5px 0px #000000;
    z-index: 100;
    height: 5px;
    width: 100%;
    overflow: hidden;
  }
  .progressBar {
    position: absolute;
    box-shadow: inset 2px 2px 5px 0px #000000;
    height: 100%;
  }
</style>
